export const CHANGE_STATE = "CHANGE_STATE";
export const UPDATE_RECIPIENTS = "UPDATE_RECIPIENTS";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE"
export const EMAIL_TEMPLATE = "EMAIL_TEMPLATE"